import { useCallback, useState } from "react";
import OperatorProfileInterface from "../../../interfaces/OperatorProfileInterface";
import { PostZoomMeetingMessageParams } from "../../../interfaces/PostZoomMeetingMessageParams";

interface UseZoomIntegrationProps {
  operatorProfile?: OperatorProfileInterface | null;
  postZoomMeetingMessage?: (
    params: PostZoomMeetingMessageParams,
    setSubmitting: (submitting: boolean) => void,
    setErrors: (errors: Record<string, unknown>) => void,
    onSuccessCallback: () => void,
  ) => void;
  navigate: (path: string) => void;
}

export const useZoomIntegration = ({
  operatorProfile,
  postZoomMeetingMessage,
  navigate,
}: UseZoomIntegrationProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClickIcon = useCallback(() => {
    if (operatorProfile && operatorProfile.zoomConnected) {
      setIsModalOpen(true);
    } else {
      const zoomConnectSettingUrl = `/settings/profile`;
      navigate(zoomConnectSettingUrl);
    }
  }, [operatorProfile, navigate]);

  const handleModalClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handlePostZoomMeetingMessage = useCallback(
    (
      params: PostZoomMeetingMessageParams,
      setSubmitting: (submitting: boolean) => void,
      setErrors: (errors: Record<string, unknown>) => void,
      onSuccessCallback: () => void,
    ) => {
      if (postZoomMeetingMessage) {
        postZoomMeetingMessage(
          params,
          setSubmitting,
          setErrors,
          onSuccessCallback,
        );
      }
    },
    [postZoomMeetingMessage],
  );

  return {
    isModalOpen,
    handleClickIcon,
    handleModalClose,
    handlePostZoomMeetingMessage,
  };
};
